import { render, staticRenderFns } from "./VacioLayout.vue?vue&type=template&id=1fa5f779&"
import script from "./VacioLayout.vue?vue&type=script&lang=js&"
export * from "./VacioLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports